module.exports = __webpack_public_path__ + "7ce16113c3a2839f1de7b0e260aefc74.png";